<template>
  <div class="bing-nav">
    <div class="bing-main">
      <div>
        <img
          v-if="VUE_APP_VERSION == 'hprt'"
          class="bing-left-img1 here-logo"
          src="../../assets/here/here-logo.png"
          alt=""
        />
        <img v-else class="bing-left-img1" src="../../assets/logo.png" alt="" />
      </div>
      <div class="bing-content">
        <div class="bing-left loginPic"></div>
        <div class="bing-right">
          <div class="bing-right-head">
            <div class="bing-title">{{ $t(`navbar.bind`) }}</div>
            <div class="bing-title-right" @click="back">
              {{ $t(`button.backLogin`) }}
            </div>
          </div>
          <div class="bing-right-head-tip">
            {{ $t(`tips.tip63`) }}
          </div>

          <a-form ref="formRef" :model="formState" :rules="rules">
            <a-form-item name="account">
              <a-input
                @input="accountInput"
                :class="errArray.errAccount ? 'errStyle' : ''"
                v-model:value="formState.account"
                :placeholder="$t(`tips.tip7`)"
              />
            </a-form-item>
            <a-form-item name="code">
              <a-input
                :class="errArray.errCode ? 'errStyle' : ''"
                v-model:value="formState.code"
                :placeholder="$t(`tips.tip8`)"
              />
              <div class="bing-postion-abs">
                <a-button @click="handleGetCode" v-if="timer > 59">{{
                  $t(`button.getCode`)
                }}</a-button>
                <a-button v-else>{{ timer }}</a-button>
              </div>
            </a-form-item>
          </a-form>
          <div class="bing-btn">
            <a-button @click="handleBind">{{
              $t(`button.bingLogin`)
            }}</a-button>
          </div>
        </div>
      </div>
    </div>
    <div class="beihao">
      Xiamen Hanin Co.,Ltd. ALL RIGHTS RESERVED.
      ©2016-{{new Date().getFullYear()}}
      <a
        v-if="VUE_APP_VERSION == 'hprt'"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >闽ICP备17017244号-2</a
      >
      <a
        v-else
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >闽ICP备17017244号-5</a
      >
    </div>
    <a-modal
      :title="$t(`tips.tip81`)"
      centered
      :visible="showModal"
      :cancelText="$t(`button.cancel`)"
      :okText="$t(`button.confirm`)"
      @cancel="handleCancel"
      @ok="getPhoneCode"
    >
      <div class="verify-box">
        <img :src="verifyInfo.image" alt="" />
        <a-input v-model:value="verify_code" :placeholder="$t(`tips.tip8`)" />
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  defineComponent,
  getCurrentInstance,
  ref,
  reactive,
  toRefs,
  watch,
  onMounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { getSign } from "@/utils/signature";
import { message } from "ant-design-vue";
import { validateAccount } from "@/utils/validate";
import {
  setAuthorization,
  getAuthorization,
  checkAuthorization,
} from "@/utils/request";
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axios;

    const state = reactive({
      showModal: false,
      formRef: null,
      formState: {
        account: "",
        code: "",
      },
      verify_code: "",
      textTime: null,
      errArray: {
        errAccount: false,
        errCode: false,
      },
      rules: {
        account: {
          required: true,
          validator: validateAccount,
          trigger: "change",
        },
        code: {
          required: true,
          message: proxy.$t(`tips.tip8`),
          trigger: "change",
        },
      },
      appId: "a0f0e723-f2bb-11e8-bc50-00163e0c395e",
      appKey: "a0f12ce4-f2bb-11e8-bc50-00163e0c395e",
      verifyInfo: {},
      third_type: 1,
      openId: "",
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
    });
    onMounted(() => {
      state.third_type = Number(route.query.third_type);
      state.openId = route.query.openId;
    });

    //获取验证码图片码
    const getCodeVerify = () => {
      let param = {
        timestamp: Date.parse(new Date()) / 1000,
        fun: "getCodeVerify",
        requestType: "User",
        appId: state.appId,
        appKey: state.appKey,
        smsType: 5,
      };
      var signature = getSign(param);
      var obj = JSON.parse(JSON.stringify(param));
      obj.signature = signature;
      axios("/api/apiservice/apiroute", obj).then((res) => {
        state.verifyInfo = res;
      });
    };
    const back = () => {
      router.push("/login");
    };
    const accountInput = (e) => {
      clearTimeout(state.textTime);
      state.errArray.errAccount = false;
      state.textTime = setTimeout(() => {
        var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        var rel2 = /^1([3456789])\d{9}$/;
        if (e.target.value == "") {
          state.errArray.errAccount = true;
        } else if (!rel1.test(e.target.value) && !rel2.test(e.target.value)) {
          state.errArray.errAccount = true;
        } else {
          state.errArray.errAccount = false;
        }
        setTimeout(() => {
          state.errArray.errAccount = false;
        }, 1000);
        state.textTime = null;
      }, 600);
    };
    //获取手机验证码
    const getPhoneCode = () => {
      if (!state.verify_code) {
        message.error(proxy.$t(`tips.tip8`));
        return;
      }
      let param = {
        timestamp: Date.parse(new Date()) / 1000,
        fun: "sendBindingMobile",
        requestType: "User",
        appId: state.appId,
        appKey: state.appKey,
        third_type: state.third_type,
        phone: state.formState.account,
        verify_code: state.verify_code,
        session_id: state.verifyInfo.session_id,
      };
      var signature = getSign(param);
      var obj = JSON.parse(JSON.stringify(param));
      obj.signature = signature;
      axios("/api/apiservice/apiroute", obj)
        .then((res) => {
          console.log(res);
          message.success(proxy.$t(`tips.tip54`));
          state.showModal = false;
          codeTimer = setInterval(() => {
            if (timer.value > 1) {
              timer.value--;
            } else {
              timer.value = 60;
              clearInterval(codeTimer);
            }
          }, 1000);
        })
        .catch((err) => {
          state.showModal = false;
        });
    };
    const handleCancel = () => {
      state.showModal = false;
      state.verify_code = "";
    };
    //获取邮箱验证码
    let timer = ref(60);
    let codeTimer = "";
    const handleGetCode = () => {
      if (!state.formState.account) {
        message.error(proxy.$t(`tips.tip7`));
        return;
      }
      var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      var rel2 = /^1([3456789])\d{9}$/;
      if (rel1.test(state.formState.account)) {
        let email = state.formState.account;
        let param = {
          fun: "bindSendEmail",
          timestamp: Date.parse(new Date()) / 1000,
          requestType: "User",
          appId: state.appId,
          appKey: state.appKey,
          email,
          third_type: state.third_type,
        };
        var signature = getSign(param);
        var form = JSON.parse(JSON.stringify(param));
        form.signature = signature;
        axios("/api/apiservice/apiroute", form).then((res) => {
          message.success(proxy.$t(`tips.tip54`));
          codeTimer = setInterval(() => {
            if (timer.value > 1) {
              timer.value--;
            } else {
              timer.value = 60;
              clearInterval(codeTimer);
            }
          }, 1000);
        });
      } else if (rel2.test(state.formState.account)) {
        getCodeVerify();
        state.showModal = true;
      } else {
        message.error(proxy.$t(`tips.tip18`));
        return;
      }
    };

    // 第三方绑定
    const handleBind = () => {
      console.log(111);
      var rel1 = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      var rel2 = /^1([3456789])\d{9}$/;
      state.formRef
        .validate()
        .then(() => {
          var timestamp = Date.parse(new Date()) / 1000;
          let phone = state.formState.account;
          let email = state.formState.account;
          let code = state.formState.code;
          console.log(state.formState);
          if (rel1.test(state.formState.account)) {
            //绑定邮箱
            let accountType = 2;

            let param = {
              timestamp,
              fun: "bindThirdAccount",
              requestType: "User",
              appId: state.appId,
              appKey: state.appKey,
              email,
              code,
              accountType,
              openid: state.openId,
              source: 1,
              third_type: state.third_type,
            };
            var signature = getSign(param);
            var obj = JSON.parse(JSON.stringify(param));
            obj.signature = signature;
          } else if (rel2.test(state.formState.account)) {
            //绑定手机号
            var accountType = 1;
            let param = {
              timestamp,
              fun: "bindThirdAccount",
              requestType: "User",
              appId: state.appId,
              appKey: state.appKey,
              phone,
              code,
              accountType,
              openid: state.openId,
              source: 1,
              third_type: state.third_type,
            };
            var signature = getSign(param);
            var obj = JSON.parse(JSON.stringify(param));
            obj.signature = signature;
          } else {
            message.error(proxy.$t(`tips.tip18`));
            return;
          }
          axios("/api/apiservice/apiroute", obj).then((res) => {
            afterLogin(res);
            localStorage.setItem("newUser", "true");
            localStorage.setItem("firstEdit", "true");
            setTimeout(() => {
              router.push("/home");
            }, 1000);
            message.success(proxy.$t(`tips.tip66`));
          });
        })
        .catch((error) => {
          if (
            !rel1.test(state.formState.account) &&
            !rel2.test(state.formState.account)
          ) {
            state.errArray.errAccount = true;
          }
          if (state.formState.code == "") {
            state.errArray.errCode = true;
          }
          setTimeout(() => {
            state.errArray.errAccount = false;
            state.errArray.errCode = false;
          }, 1000);
        });
    };
    const afterLogin = (res) => {
      let t = new Date(new Date().getTime() + 30 * 60 * 1000);
      setAuthorization({
        token: res.token,
        expireAt: new Date(t),
      });
      localStorage.setItem("userInfo", JSON.stringify(res));
    };

    return {
      timer,
      ...toRefs(state),
      handleBind,
      handleGetCode,
      back,
      accountInput,
      getPhoneCode,
      handleCancel,
    };
  },
});
</script>
<style scoped>
.verify-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}
.verify-box img {
  width: 50%;
  margin-right: 16px;
}
.beihao {
  position: absolute;
  bottom: 15px;
  font-size: 12px;
  color: #666;
  width: 100%;
  text-align: center;
}
a {
  color: #666;
}
.bing-nav {
  width: 100%;
  height: 100%;
  background: rgba(57, 106, 193, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
}
.bing-main {
  width: 1200px;
  height: 680px;
  background: #ffffff;
  border-radius: 0px 4px 4px 0px;
  padding: 48px 50px;
}
.bing-left-img1 {
  width: 224px;
  height: 56px;
  display: block;
}
.here-logo {
  width: 100px;
  height: 55px;
}
.bing-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bing-left {
  width: 50%;
  margin-top: 24px;
  height: 480px;
  background-size: 100% 100%;
}

.bing-right {
  width: 50%;
  padding-left: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.bing-right-head {
  width: 480px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.bing-right-head-tip {
  min-height: 26px;
  font-size: 18px;
  color: #535d6c;
  line-height: 26px;
  margin-bottom: 34px;
}
.bing-title {
  height: 36px;
  font-size: 24px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 36px;
}
.bing-title-right {
  height: 26px;
  font-size: 18px;
  font-weight: 500;
  color: #003591;
  line-height: 26px;
  cursor: pointer;
}
.bing-right ::v-deep(.ant-input) {
  width: 480px;
}
.bing-right ::v-deep(.ant-input-affix-wrapper) {
  width: 480px;
}

.bing-postion-abs {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 99;
}
.bing-postion-abs ::v-deep(.ant-btn) {
  height: 37px;
  border: none;
  font-size: 16px;
  color: #003591;
  line-height: 22px;
  background: none;
}
.bing-btn {
  margin-top: 12px;
}
.bing-btn ::v-deep(.ant-btn) {
  width: 480px;
  height: 46px;
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}
@media only screen and (max-width: 1300px) {
  .bing-main {
    width: 800px;
    height: 453px;
    padding: 32px 33px;
  }
  .bing-left {
    margin-top: 16px;
    height: 320px;
  }
  .bing-left-img1 {
    width: 150px;
    height: 37px;
    top: 27px;
    left: 32px;
  }
  .here-logo {
    width: 66px;
    height: 36px;
  }
  .bing-right {
    padding-left: 30px;
  }
  .bing-right-head {
    width: 320px;
    margin-bottom: 5px;
  }
  .bing-right-head-tip {
    min-height: 24px;
    font-size: 14px;
    line-height: 24x;
    margin-bottom: 22px;
  }
  .bing-title {
    height: 24px;
    font-size: 16px;
    line-height: 24px;
  }
  .bing-title-right {
    height: 17px;
    font-size: 12px;
    line-height: 17px;
  }
  .bing-right ::v-deep(.ant-input) {
    width: 320px;
  }
  .bing-right ::v-deep(.ant-input-affix-wrapper) {
    width: 320px;
  }
  .bing-postion-abs ::v-deep(.ant-btn) {
    height: 25px;
    font-size: 10px;
    margin-right: 10px;
  }
  .bing-btn {
    margin-top: 5px;
  }
  .bing-btn ::v-deep(.ant-btn) {
    width: 320px;
    height: 37px;
    font-size: 14px;
    line-height: 17px;
  }
  .verify-box {
    width: 100%;
    margin-top: 16px;
  }
  .verify-box img {
    width: 50%;
    margin-right: 14px;
  }
}
</style>
